var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98 15.214 19.29 3.338A.938.938 0 0 1 19.998 3C20.551 3 21 3.517 21 4.154c0 .319-.112.607-.294.816L9.688 17.662A.937.937 0 0 1 8.98 18a.937.937 0 0 1-.708-.338l-5.008-5.769a1.251 1.251 0 0 1-.264-.78c0-.637.449-1.154 1.002-1.154.262 0 .5.116.679.305l4.299 4.95Z",
    fill: "currentColor"
  })));
};
export default SvgCheck;